/**
 * 将库中存的路径转为浏览器可请求的绝对地址。
 * 绝对 URL（http/https//）与 data: 原样返回；相对路径拼到 VUE_APP_API_ORIGIN（与接口同源、静态站点的根）。
 */
export function resolveFileUrl (path) {
  if (path == null) return ''
  const u = String(path).trim()
  if (!u) return ''
  if (/^https?:\/\//i.test(u) || u.startsWith('//') || u.startsWith('data:')) {
    return u
  }
  const base = (process.env.VUE_APP_API_ORIGIN || '').replace(/\/$/, '')
  if (!base) {
    return u.startsWith('/') ? u : `/${u}`
  }
  return u.startsWith('/') ? base + u : `${base}/${u}`
}
